import OwnerHeroStrip from "./OwnerHeroStrip";
import OwnerAdminRow from "./OwnerAdminRow";
import TapTrackIntelligence from "./TapTrackIntelligence";
import RevenueLeaks from "./RevenueLeaks";
import ManagerScorecards from "./ManagerScorecards";
import RecoveryProgress from "./RecoveryProgress";
import PromotionRadar from "./PromotionRadar";
import RiskRadar from "./RiskRadar";

/**
 * Owner Overview V2 — command centre layout.
 * 5 rows above the fold (money · action · management · governance · admin).
 *
 * NOTE — IA cleanup (2026-02-28):
 *   - BoardSnapshot removed from Row 4 → Operational Record §8 is the
 *     canonical owner of the board-narrative read surface. The Board Pack
 *     export trigger remains in OwnerHeroStrip Row 1.
 */
export default function OwnerOverviewV2({ onNavigate, onOpenFundraiser, isManager = false }) {
  return (
    <div className="space-y-6" data-testid="owner-overview-v2">
      {/* ROW 1 — HERO: Revenue Captured · Revenue At Risk · Team Grade · Export Board Pack
          (owner-only endpoints — hidden for managers to avoid unauthorised calls) */}
      {!isManager && <OwnerHeroStrip />}

      {/* ROW 2 — ACTIONS: Today's Opportunities + Revenue Leaks */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {!isManager && (
          <TapTrackIntelligence
            onNavigate={onNavigate}
            onOpenFundraiser={onOpenFundraiser}
          />
        )}
        <RevenueLeaks
          onNavigate={onNavigate}
          onOpenFundraiser={onOpenFundraiser}
        />
      </div>

      {/* ROW 3 — MANAGEMENT: Manager Scorecards + Recovery Progress */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ManagerScorecards />
        {!isManager && <RecoveryProgress />}
      </div>

      {/* ROW 4 — GOVERNANCE: Promotion Radar + Risk Radar (owner-only) */}
      {!isManager && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <PromotionRadar />
          <RiskRadar />
        </div>
      )}

      {/* ROW 5 — ADMIN: Billing · Diagnostics · Integrations (owner-only) */}
      {!isManager && <OwnerAdminRow onNavigate={onNavigate} />}
    </div>
  );
}
